/**
 * AppStoreButton — Apple App Store download button.
 *
 * Presentational only: give it a resolved `href` (build one with
 * `generateAppStoreLink` / `generateAppStoreLinks` from `@butter/library/shared`).
 *
 * @module butterUI/domains/app/AppStoreButton
 */

import { AppleIcon } from '#icons';
import { StoreLinkButton } from './StoreLinkButton';

export interface AppStoreButtonProps {
  /** App Store URL. */
  href: string;
  className?: string;
}

export function AppStoreButton({ href, className }: AppStoreButtonProps) {
  return (
    <StoreLinkButton
      href={href}
      className={className}
      icon={<AppleIcon className="h-6 w-6" />}
      topLine="Download on the"
      bottomLine="App Store"
    />
  );
}
